module.exports = __webpack_public_path__ + "img/rok.3e1aaa04.jpg";